module.exports = (__webpack_require__(11))(80);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/fbjs/lib/getActiveElement.js from dll-reference vendor_lib
// module id = 215
// module chunks = 0